import type { QueryClient, QueryFunction, QueryKey } from '@tanstack/react-query'

/**
 * Make a key's own `queryFn` the cache's default for it, so the entry is fetchable however it was created.
 *
 * An observer's own options still win, and a default cannot change a query hash. Which entries have no
 * `queryFn` of their own, and what it costs: docs/notes/app/query-persistence.md
 */
export function fetchableByDefault(client: QueryClient, options: { queryKey: QueryKey; queryFn?: unknown }): void {
  if (typeof options.queryFn !== 'function') return
  client.setQueryDefaults(options.queryKey, { queryFn: options.queryFn as QueryFunction })
}
